import React, { useState } from 'react';
import ContentCard from '../Layouts/ContentCard';
import ProjectList from '../Components/Project/ProjectList';
import { FaPlus, FaRegFolder } from 'react-icons/fa6';
import ActionCard from '../Layouts/ActionCard';
import Breadcrumbs from '../Components/Breadcrumbs/Breadcrumbs';
import { useDispatch } from 'react-redux';
import { openModal } from '../Store/modalSlice';
import ProjectActionButtons from '../Components/Project/ProjectActionButtons';
import { useProjectCreation } from '../hooks/useProjectCreation';

export default function ProjectsPage() {

    const [projectsAreSelected, setProjectsAreSelected] = useState([])

    const dispatch = useDispatch();
    const {
        isProjectCreationDisabled,
        getProjectCreationTooltip
    } = useProjectCreation();

    return (
        <div className="container mx-auto">
            <div className="grid grid-cols-1 gap-4 mt-4">
                <div>
                    <h1 className="text-3xl font-bold mb-4"><FaRegFolder className="inline mr-3 mb-1" />Your Projects</h1>
                    <p className="text-gray-600">List of all your projects</p>
                </div>
            </div>
            {/* Create a 5 column container */}
            <div className="grid grid-cols-8 gap-4 mt-4 h-28">
                <ActionCard 
                    title="Create Project" 
                    icon={<FaPlus />} 
                    onClick={()=>dispatch(openModal({type: 'project', props: {}}))}
                    disabled={isProjectCreationDisabled}
                    tooltip={getProjectCreationTooltip()}
                />
            </div>
            {!projectsAreSelected && <Breadcrumbs />}
            {projectsAreSelected && <ProjectActionButtons/>}
            <ContentCard className="mx-0 pb-24">
                <ProjectList setProjectsAreSelected={setProjectsAreSelected} />
            </ContentCard>
        </div>
    );

}